import _ from 'lodash';

// eslint-disable-next-line import/no-named-as-default
import ajax from 'Modules/ajax';

export const FETCH_USERS_URL = '/mp/recipients/searchList';
export const MAX_USERS_PER_REQUEST = 20;

export function fetch(userIds) {
  const chunks = _.chunk(userIds, MAX_USERS_PER_REQUEST);
  const calls = chunks.map((chunk) =>
    ajax.get(FETCH_USERS_URL, {
      data: { users: chunk.join(',') },
    })
  );

  return Promise.all(calls).then((results) => _.flow(_.map, _.flatten)(results, 'data'));
}

export default { fetch };
